import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';

@Directive({
    selector: '[phoneMask]'
})
export class PhoneMaskDirective implements OnInit, OnDestroy {

    private _phoneControl: AbstractControl | null = null;

    private _preValue: string = '';

    private _maskInputId: string = '';

    @Input()
    set phoneControl(control: AbstractControl) {
        this._phoneControl = control;
    }

    @Input()
    set preValue(value: string) {
        this._preValue = value;
    }

    @Input()
    set maskInputId(value: string) {
        this._maskInputId = value;
    }

    getMaskInputIdTag(): string {
        return '#' + this._maskInputId;
    }

    private sub: Subscription | undefined = undefined;

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    ngOnInit() {
        this.phoneValidate();
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }

    phoneValidate() {

        this.sub = this._phoneControl?.valueChanges.subscribe(data => {

            if (data) {

                let preInputValue: string | null = this._preValue;
                var lastChar: string = '';

                if (preInputValue) {
                    lastChar = preInputValue.substr(preInputValue.length - 1);
                }

                var newVal = data.replace(/\D/g, '');

                let start = this.renderer.selectRootElement(this.getMaskInputIdTag()).selectionStart;
                let end = this.renderer.selectRootElement(this.getMaskInputIdTag()).selectionEnd;

                if (preInputValue && data.length < preInputValue.length) {

                    if (preInputValue.length < start) {
                        if (lastChar && lastChar == ')') {
                            newVal = newVal.substr(0, newVal.length - 1);
                        }
                    }

                    if (newVal.length == 0) {
                        newVal = '';
                    } else if (newVal.length <= 2) {
                        newVal = newVal.replace(/^(\d{0,2})/, '($1)');
                    } else if (newVal.length <= 6) {
                        newVal = newVal.replace(/^(\d{0,2})(\d{0,4})/, '($1) $2');
                    } else if (newVal.length <= 10) {
                        newVal = newVal.replace(/^(\d{0,2})(\d{0,4})(.*)/, '($1) $2-$3');
                    } else {
                        newVal = newVal.replace(/^(\d{0,2})(\d{0,1})(\d{0,4})(.*)/, '($1) $2 $3-$4');
                    }

                    this._phoneControl?.setValue(newVal, { emitEvent: false });

                    this.renderer.selectRootElement(this.getMaskInputIdTag()).setSelectionRange(start, end);

                } else {

                    var removedD = data.charAt(start);

                    if (newVal.length == 0) {
                        newVal = '';
                    } else if (newVal.length <= 2) {
                        newVal = newVal.replace(/^(\d{0,2})/, '($1)');
                    } else if (newVal.length <= 6) {
                        newVal = newVal.replace(/^(\d{0,2})(\d{0,4})/, '($1) $2');
                    } else if (newVal.length <= 10) {
                        newVal = newVal.replace(/^(\d{0,2})(\d{0,4})(.*)/, '($1) $2-$3');
                    } else {
                        newVal = newVal.replace(/^(\d{0,2})(\d{0,1})(\d{0,4})(.*)/, '($1) $2 $3-$4');
                    }

                    if (preInputValue && preInputValue.length >= start) {

                        if (removedD == '(') {
                            start = start + 1;
                            end = end + 1;
                        }

                        if (removedD == ')') {
                            start = start + 2;
                            end = end + 2;
                        }

                        if (removedD == '-') {
                            start = start + 1;
                            end = end + 1;
                        }

                        if (removedD == " ") {
                            start = start + 1;
                            end = end + 1;
                        }

                        this._phoneControl?.setValue(newVal, { emitEvent: false });
                        this.renderer.selectRootElement(this.getMaskInputIdTag()).setSelectionRange(start, end);
                    } else {
                        this._phoneControl?.setValue(newVal, { emitEvent: false });
                        this.renderer.selectRootElement(this.getMaskInputIdTag()).setSelectionRange(start + 2, end + 2); // +2 because of wanting standard typing
                    }
                }
            }
        });
    }
}
